import Vue from 'vue';
export enum EventBusEvents {
    MODAL_SHOW = 'modal:show',
    LOGIN_SUCCESS = 'login:success',
    REGISTER_SUCCESS = 'register:success'
}
export const EventBus = new Vue();
